(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sites/import_osm_view', {
            templateUrl: 'partials/openbase/sites_import_osm_view.html',
            controller: OpenbaseSitesImportOSMController,
            controllerAs: '$ctrl',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (service) {
                    return service.check();
                }]
            }
        });
    }


    function OpenbaseSitesImportOSMController($scope, $location, swif, openbase, osmOverpassAPI, osmNominatim, osmTagInfoAPI) {
        'ngInject';
        var $ctrl = this;
        var hasCarto = swif.module.modules.opengst_carto;
        $ctrl.overpass = {};
        $ctrl.overpass.query_has_name = true;
        $scope.loading = {overpass: {}, nominatim: {}, import_data: {}};
        $ctrl.tagValues = [];
        $ctrl.config = {};
        $ctrl._parent = {};

        $ctrl.nominatimQuery = function () {
            swif.message.loading($scope.loading.nominatim);
            osmNominatim.search($ctrl.nominatim.query)
            .then(function (data) {
                swif.message.loading($scope.loading.nominatim, 'ok');
                $ctrl.nominatim.results = data.data;
            }, function (error) {
                swif.message.loading($scope.loading.nominatim, 'ko');
                $ctrl.nominatim.error = error;
            });
        };
        $ctrl.setNominatimResult = function (result) {
            $ctrl.nominatim.selected = result;
            $ctrl.overpass.area_id = osmOverpassAPI.getAreaId(result.osm_type, result.osm_id);
        };

        $ctrl.choices = {
            overpass: [
                {id: 'amenity', value:'["amenity"="school"]', name: 'School'},
                {id: 'highway', value:'["highway"]', name: 'Voirie'},
                {id: 'building', value:'["building"]', name: 'Bâtiments'},
                {id: 'leisure', value:'["leisure"]', name: 'Espaces'},
                {id: 'place', value:'["place"]', name: 'Place (village, hameau)'},
                {id: 'boundary', value:'["type"="boundary"]["admin_level"="8"]', name: 'Limite administrative 8'}
            ]
        };
        $ctrl.overpassQuery = function () {
            swif.message.loading($scope.loading.overpass);
            var query = $ctrl.overpass.query;
            osmOverpassAPI.overpass(query)
            .then(function (data) {
                swif.message.loading($scope.loading.overpass, 'ok');
                $ctrl.overpass.data = data;
            });
        };
        $ctrl.import_data = importData;
        $ctrl.goback = function () {
            $location.path('/configuration/sites/table_view');
        };
        $ctrl.buildOverpassQuery = buildOverpassQuery;
        $scope.$watch('$ctrl.overpass.query_id', watchQueryId);
        $scope.$watch('$ctrl.overpass.area_id', deleteOverpass);
        $scope.$watch('$ctrl.overpass.data', function (newV) {
            if (newV) {
                extractSitesFromOverpass(newV, $ctrl.typeKey);
            }
        });
        $scope.$watch('$ctrl.config', watchConfig, true);

        function importData() {
            swif.message.loading($scope.loading.import_data);
            var data = [];
            $ctrl.sites.forEach(function onSite(site) {
                if (site.type && site.name) {
                    var site_parent_id = $ctrl._parent.site ? $ctrl._parent.site[0] : null;
                    if (site_parent_id === null) {
                        site_parent_id = false;
                    }
                    var service_ids = '';
                    if (!_.isEmpty(site.service_ids)) {
                        service_ids = site.service_ids.join(',');
                    }
                    if (hasCarto) {
                        data.push([
                            site.name,
                            site.type[0],
                            site_parent_id,
                            service_ids,
                            site.geo_point,
                            site.osm_type,
                            site.osm_id
                        ]);
                    } else {
                        data.push([
                            site.name,
                            site.type[0],
                            site_parent_id,
                            service_ids,
                            site.lat,
                            site.long,
                            'osm_' + site.osm_type + '_' + site.osm_id
                        ]);
                    }
                }
            });
            var fields;
            if (hasCarto) {
                fields = [
                    'name',
                    'type_id/.id',
                    'site_parent_id/.id',
                    'service_ids/.id',
                    'geo_point',
                    'osm_type',
                    'osm_id'
                ];
            } else {
                fields = [
                    'name',
                    'type_id/.id',
                    'site_parent_id/.id',
                    'service_ids/.id',
                    'lat',
                    'long',
                    'code'
                ];
            }

            openbase.wizard.import_data('site', fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import_data, 'ok');
                swif.message.addInfo('data imported successfully');
            }, function (error) {
                swif.message.loading($scope.loading.import_data, 'ko');
                swif.message.addError(error);
            });
        }


        function watchQueryId(newV) {
            deleteSites();
            if (newV) {
                buildOverpassQuery();
            }
        }
        function buildOverpassQuery() {
            var query;
            var name = '';
            if ($ctrl.overpass.query_has_name) {
                name = '["name"]';
            }
            var choosen;
            _.forEach($ctrl.choices.overpass, function (choice) {
                if (choice.id === $ctrl.overpass.query_id[0]) {
                    choosen = choice;
                }
            });
            query = '[out:json][timeout:25];area(';
            query += $ctrl.overpass.area_id;
            query += ')->.searchArea;(';
            if ($ctrl.overpass.query_text) {
                query += $ctrl.overpass.query_text;
            }
            query += 'node' + choosen.value + name + '(area.searchArea);';
            query += 'way' + choosen.value + name + '(area.searchArea);';
            query += 'relation' + choosen.value + name + '(area.searchArea);';
            $ctrl.typeKey = $ctrl.overpass.query_id[0];
            loadTagInfo(choosen.id);
            query += ');';
            query += 'out body;>;out skel qt;';
            $ctrl.overpass.query = query;
        }


        function watchConfig(newV) {
            if (!$ctrl.sites) {
                return;
            }
            _.forOwn(newV, function (value, key) {
                //key === tag value
                //value = {type, site_parent_id, service_ids}
                $ctrl.sites.forEach(function onSite(site) {
                    if (site.osm_key_value === key) {
                        site.type = value.type || false;
                        site.service_ids = value.service_ids || false;
                        site.site_parent_id = value.site_parent_id || false;
                    }
                });
            });
        }
        function setLocalisation (container, element) {
            container.long = element.lon;
            container.lat = element.lat;
            container.geo_point = `{"type": "Point", "coordinates": [${element.lon}, ${element.lat}]}`;
        }
        function extractSitesFromOverpass(osmdata, typeKey) {
            $ctrl.tagValues = [];
            var TYPE = typeKey;
            var names = [];
            var name;
            var elements = osmdata.elements || [];
            var data = {};
            elements.forEach(function onElement(element) {
                if (!element.tags){
                    return;
                }
                //ref tag is usefull for streets
                if (!element.tags.name && !element.tags.ref) {
                    return;
                }
                name = element.tags.name || element.tags.ref;
                if (!_.contains(names, name)) {
                    names.push(name);
                    let osm_url = `http://www.openstreetmap.org/${element.type}/${element.id}`;
                    data[element.id] = {
                        osm_id: parseInt(element.id),
                        osm_type: element.type,
                        osm_url: osm_url,
                        osm_key_value: element.tags[TYPE],
                        name: name,
                        tags: element.tags
                    };
                    if (!_.contains($ctrl.tagValues, element.tags[TYPE])) {
                        $ctrl.tagValues.push(element.tags[TYPE]);
                    }
                    if (element.type === 'node') {
                        setLocalisation(data[element.id], element);
                    }
                    if (element.type === 'way') {
                        var nodeid = element.nodes[0];
                        _.forEach(elements, function (node) {
                            if (node.type === 'node' && node.id === nodeid) {
                                setLocalisation(data[element.id], node);
                            }
                        });
                    }
                } else {
                    _.forOwn(data, function (value) {
                        if (value.name === name && element.osm_type === 'node' && !value.lat) {
                            setLocalisation(value, element);
                        }
                    });
                }
            });

            $ctrl.sites = [];
            _.forOwn(data, function (value, key) {
                value.code = 'osm_' + TYPE + '_' + value.osm_type + '_' + key;
                $ctrl.sites.push(value);
            });

        }
        function deleteSites () {
            delete $ctrl.sites;
        }
        function deleteOverpass () {
            delete $ctrl.overpass.query_id;
            delete $ctrl.overpass.query;
            deleteSites();
        }
        function deleteNominatim () {
            delete $ctrl.nominatim.selected;
            delete $ctrl.nominatim.results;
            delete $ctrl.overpass.area_id;
            deleteOverpass();
        }
        function loadTagInfo(key) {
            $ctrl.tagInfo = {};
            var params = {
                key:key,
                lang: 'fr',
                sortname:'count',
                sortorder:'desc',
                page:1,
                rp:100
            };
            osmTagInfoAPI.getKeyValues(params)
            .then(function (data) {
                _.forEach(data.data, function (info) {
                    $ctrl.tagInfo[info.value] = info;
                });
            });
        };
    }


})();
